<template>
    <div class="container">
        <div class="teamMain">
            <div class="teamMaster">
              <div class="Mastertitle">
                <ul>
                  <li><img src="../../assets/images/adicon.png"/></li>
                  <li><h1>创始团队</h1></li>
                  <li><img src="../../assets/images/adicon.png"/></li>
                </ul>
              </div>
                <div class="masterone" v-for="(item,index) in leaderList" :key="'lea' + index" @click="showAllHonner(item.id)">
                    <div class="masterbody">
                        <div class="masterimg">
                            <img :src="item.url" width="100%" height="auto"/>
                        </div>
                        <div class="masterint">
                            <div class="mastitle">
                                <p>{{item.name}}</p>
                            </div>
                            <div class="tag"></div>
                            <div class="matposition">
                                <p>
                                    {{item.position}}
                                </p>
                            </div>
<!--                            <div class="matdegree" v-for="(item,index) in item.introduce" :key="'int' + index">-->
<!--                                <p>{{item}}</p>-->
<!--                            </div>-->
                        </div>
                    </div>
                  <div class="masterHoverBox">
                    <ul>
                      <li v-for="(item,index) in item.introduce" :key="'int' + index">
                        <span>{{item}}</span>
                      </li>
                    </ul>
                  </div>
                </div>
            </div>
            <div class="member">
                <div class="membertitle">
                    <ul>
                        <li><img src="../../assets/images/adicon.png"/></li>
                        <li><h1>团队风采</h1></li>
                        <li><img src="../../assets/images/adicon.png"/></li>
                    </ul>
                </div>
                <div class="memberbody">
                    <div class="memItem" v-for="(item,index) in staff" :key="'sta' + index">
                        <img :src="item.url" width="100%" height="auto"/>
                    </div>
                </div>
            </div>
        </div>

      <el-dialog :visible.sync="open" width="60%" append-to-body>
        <div style="width: 100%;height: auto" class="boxHonner">
          <ul>
            <li v-for="(item,index) in honnerAll" :key="'sta' + index">
              {{item}}
            </li>
          </ul>
        </div>
      </el-dialog>

    </div>
</template>
<script>
import axios from 'axios'
export default {
    data() {
        return{
          leaderList:[],
          staff:[],
          open:false,
          masterHonnerList:[],
          honnerAll:[]
        }
    },
    methods:{
      getLeaderInfo(){
        axios.get('http://www.thingo.com.cn/thingo-server/website/enterThingo/group/' + 1).then(res => {
          this.leaderList = res.data.data
          for (let i=0; i<this.leaderList.length; i++) {
            this.leaderList[i].introduce = this.leaderList[i].introduce.split(",")
            if (this.leaderList[i].introduce.length > 6) {
              console.log(1)
              this.leaderList[i].introduce.splice(5)
            }
          }

        })
      },
      getStaffInfo(){
        axios.get('http://www.thingo.com.cn/thingo-server/website/enterThingo/group/' + 2).then(res => {
          this.staff = res.data.data
        })
      },
      showAllHonner(id){
        this.honnerAll = []
        axios.get('http://www.thingo.com.cn/thingo-server/website/enterThingo/group/' + 1).then(res => {
          this.masterHonnerList = res.data.data
          for (let i=0; i<this.masterHonnerList.length; i++) {
            this.masterHonnerList[i].introduce = this.masterHonnerList[i].introduce.split(",")
          }
          let info = this.masterHonnerList.find(item => Number(item.id) === Number(id))
          this.honnerAll = info.introduce
        })
        this.open = true
      }

    },
  mounted() {
      this.getLeaderInfo()
      this.getStaffInfo()
  }
}
</script>

<style scoped>
    .boxHonner ul li{
      line-height: 22px;
      font-size: 15px;
      margin-top: 8px;
    }
    .teamMain{
        width: 100%;
        height: auto;
    }
    .teamMain .teamMaster{
        width: 75%;
        height: auto;
        margin: 0 auto;
        text-align: center;
      position: relative;
      left: 0.5%;
    }
    .teamMain .teamMaster .masterone{
        width: 40%;
        height: 345px;
        display: inline-block;
        margin-right: 25px;
        margin-top: 25px;
        border: 1px solid #e2eaf3;
        border-radius: 20px;
        background:url('../../assets/images/musterbg.png') no-repeat;
        background-size: 100% 100%;
        background-attachment: fixed;
        position: relative;
        cursor: pointer;
    }

    .teamMain .teamMaster .masterone .masterHoverBox{
      width: 100%;
      height: 100%;
      position: absolute;
      background-color: rgba(0,0,0,.7);
      top: 0;
      border-radius: 20px;
      display: none;


    }


    .teamMain .teamMaster .masterone .masterHoverBox ul{
      padding: 30px;
      position: relative;
      top: 22%;
    }

    .teamMain .teamMaster .masterone .masterHoverBox ul li {
        color: #FFFFFF;
        text-align: left;
        font-size: 14px;
        margin-top: 5px;

    }

    .teamMain .teamMaster .masterone .masterHoverBox ul li span{
      letter-spacing: 0.5px;
    }


    .teamMain .teamMaster .masterone:hover .masterHoverBox{
      display: block;
    }

    .teamMain .teamMaster .mastertwo{
        width: 40%;
        height: 345px;
        display: inline-block;
        border: 1px solid #e2eaf3;
        margin-left: 25px;
        border-radius: 20px;
        background:url('../../assets/images/musterbg.png') no-repeat;
        background-size: 100% 100%;
        background-attachment: fixed;
    }
    .teamMain .teamMaster .masterbody{
        width: 100%;
        height: 345px;
        display: flex;
    }
    .teamMain .teamMaster .masterimg{
        width: 213px;
        height: 343px;
        display: inline-block;
        position: relative;
        bottom: 30px;
        margin-left: 30px;
    }
    .teamMain .teamMaster .masterint{
        width: 288px;
        height: 300px;
        display: inline-block;
        margin-left: 30px;
    }
    .teamMain .teamMaster .masterint .mastitle p{
        margin: 40% 0 10px 0;
        padding: 0;
        text-align: left;
        font-size: 36px;
        font-family: 'PingFang SC', 'PingFang SC-Bold';
        font-weight: 700;
        color: #000000;
    }
    .teamMain .teamMaster .masterint .tag{
        width: 35px;
        height: 3px;
        background:url('../../assets/images/mastertag.png');
    }
    .teamMain .teamMaster .masterint .matposition p{
        margin: 20px 0;
        padding: 0;
        text-align: left;
        font-size: 24px;
        font-family: 'PingFang SC', 'PingFang SC-Bold';
        font-weight: 500;
        color: #000000;
    }
    .teamMain .teamMaster .masterint .matdegree p{
        margin: 5px 0;
        padding: 0;
        text-align: left;
        font-size: 16px;
        font-family: 'PingFang SC', 'PingFang SC-Bold';
        font-weight: 400;
        color: #4f5768;
    }
    .member{
        width: 100%;
        height: auto;
    }

    .teamMaster .Mastertitle{
      width: 100%;
      height: 70px;
      margin: 0 auto;
      position: relative;
      top: 0;
      text-align: center;
    }

    .teamMaster .Mastertitle ul{
      margin: 0;
      padding: 0;
    }

    .teamMaster .Mastertitle ul li {
      list-style: none;
      display: inline-block;
      margin-left: 10px;
      margin-right: 10px;
      color: #000000;
    }

    .member .membertitle{
        width: 100%;
        height: 50px;
        margin: 0 auto;
        position: relative;
        top: 60px;
        text-align: center;
    }
    .member .membertitle ul{
        margin: 0;
        padding: 0;
    }
    .member .membertitle ul li{
        list-style: none;
        display: inline-block;
        margin-left: 10px;
        margin-right: 10px;
        color: #000000;
    }
    .member .memberbody{
        width: 75%;
        height: auto;
        margin: 0 auto;
        position: relative;
        top: 100px;
        padding-bottom: 100px;
        text-align: center;

    }
    .memItem{
        width: 40%;
        margin: 10px 10px;
        display: inline-block;

    }
    .member .memberbody .memItem img{
      border-radius: 20px ;
    }
    @media screen and (max-width: 1400px) {
        .teamMain .teamMaster{
            width: 90%;
        }
    }
    @media screen and (max-width: 1200px) {
        .teamMain .teamMaster{
            width: 100%;
        }
    }
    @media screen and (max-width: 1100px) {
        .member .memberbody{
            display: block;
        }
        .memItem{
            margin: 20px 20px;
        }
        .teamMain .teamMaster .masterone{
            width: 60%;
            margin: 10px 0;
        }
        .teamMain .teamMaster .mastertwo{
            width: 60%;
            margin: 10px 0;
        }
        .teamMain .teamMaster{
            height: auto;
        }
        .teamMain .teamMaster .masterint .matposition p{
            font-size: 18px;
        }
        .teamMain .teamMaster .masterint .matdegree p{
            font-size: 14px;
        }
    }
    @media screen and (max-width: 768px) {
        .memItem{
          width: 70%;
        }
        .teamMain .teamMaster .masterone{
            width: 80%;
        }
        .teamMain .teamMaster .mastertwo{
            width: 80%;
        }
    }
    @media screen and (max-width: 600px) {
        .memItem{
          width: 90%;
          margin: 10px 0;
        }
        .teamMain .teamMaster .masterone{
            width: 90%;
            height: auto;
        }
        .teamMain .teamMaster .mastertwo{
            width: 90%;
            height: auto;
        }
        .teamMain .teamMaster .masterint .matposition p{
            font-size: 16px;
        }
        .teamMain .teamMaster .masterint .matdegree p{
            font-size: 12px;
        }
        .teamMain .teamMaster .masterint .mastitle p{
            font-size: 36px;
        }
        .teamMain .teamMaster .masterimg{
            height: auto;
        }
        .teamMain .teamMaster .masterint{
            height: auto;
        }
        .teamMain .teamMaster .masterbody{
            height: auto;
        }

      .teamMain .teamMaster .masterone .masterHoverBox ul {
        top: 0;
      }
    }
    @media screen and (max-width: 400px) {
        .memItem{
          width: 100%;
        }
        .teamMain .teamMaster .masterint .matposition p{
            font-size: 14px;
            margin: 8px 0 8px 0;
        }
        .teamMain .teamMaster .masterint .matdegree p{
            font-size: 10px;
        }
        .teamMain .teamMaster .masterint .mastitle p{
            font-size: 30px;
            margin: 10px 0 5px 0;
        }
        .teamMain .teamMaster .masterimg{
            bottom: 10px;
        }
    }
</style>
